export default "__VITE_ASSET__BXOOyjDB__"